{
  "name": "lb3-web",
  "version": "0.1.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:staging": "ng build --configuration=pfuschbet-dev",
    "watch": "ng build --watch --configuration development",
    "test": "node test.js",
    "lint": "ng lint",
    "e2e": "playwright test",
    "start:pfuschbet": "ng serve --configuration=pfuschbet-local"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.19",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.19",
    "@angular/compiler": "21.2.19",
    "@angular/core": "21.2.19",
    "@angular/forms": "21.2.19",
    "@angular/material": "21.2.14",
    "@angular/platform-browser": "21.2.19",
    "@angular/router": "21.2.19",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "i18n-iso-countries": "^7.14.0",
    "jquery": "^3.7.1",
    "material-symbols": "^0.31.9",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "21.2.20",
    "@angular/cli": "21.2.20",
    "@angular/compiler-cli": "21.2.19",
    "@axe-core/playwright": "^4.12.1",
    "@playwright/test": "1.55.1",
    "@types/jasmine": "~5.1.0",
    "@types/jquery": "^3.5.32",
    "@types/signalr": "^2.4.3",
    "angular-eslint": "21.2.0",
    "eslint": "^9.33.0",
    "jasmine-core": "~5.7.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "puppeteer": "^24.10.2",
    "typescript": "~5.9.3",
    "typescript-eslint": "8.56.1"
  }
}
